import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as firebase from "firebase/app";
import { AngularFireAuth } from "angularfire2/auth";
import {
  AngularFirestore,
  AngularFirestoreDocument
} from "angularfire2/firestore";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/switchMap";
import { User } from "../models/user";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class AuthService {
  user: Observable<User>;
  loginState: boolean = false;
  adminLogin: boolean = false;
  userId: string;
  userName: string;

  userObject: object = {
    userId: "",
    userName: "",
    userEmail: "",
    userBio: ""
  };

  instaAccessToken = "https://api.instagram.com/oauth/authorize/?client_id=${env.CLIENT_ID}&redirect_uri=${env.REDIRECT_URI}&response_type=code";

  // store the URL so we can redirect after logging in
  public redirectUrl: string;

  public loggedIn = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router
  ) {
    //// Get auth data, then get firestore user document || null
    this.user = this.afAuth.authState.switchMap(user => {
      if (user) {
        if (user.uid === "f3IEK2GGOie5qG04D79mDSCU4883") {
          this.adminLogin = true;

          console.log("Are You Admin?", this.adminLogin);
        }
        this.userId = user.uid;
        this.userName = user.displayName;
        this.userObject = {
          userId: user.uid,
          userName: user.displayName,
          userEmail: user.email,
          createdAt: new Date()
        };

        this.loggedIn.next(true);

        return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
      } else {
        return Observable.of(null);
      }
    });
  }

  getUserId() {
    return this.userId;
  }

  getUserName() {
    return this.userName;
  }

  getUserObject() {
    return this.userObject;
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return this.oAuthLogin(provider);
  }

  signInWithFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    return this.oAuthLogin(provider);
  }

  signInWithInstagram() {
    const provider = this.afAuth.auth.signInWithCustomToken(
      this.instaAccessToken
    );
    console.log(provider);
  }

  // Login popup window
  login() {
    //const popup = window.open('http://localhost:5000/redirect', '_blank', 'height=700,width=800');
    const popup = window.open(
      "https://www.instagram.com/oauth/authorize/?client_id=18bb5dafedd749c0aee4893bcb371baf&redirect_uri=http://localhost:5000/redirect&response_type=code",
      "_blank",
      "height=700,width=800"
    );
  }
  // Signin with a custom token from
  customSignIn(token) {
    return this.afAuth.auth
      .signInWithCustomToken(token)
      .then(() => window.close());
  }

  getIdToken() {
    return this.afAuth.auth.currentUser.getIdToken();
  }

  private oAuthLogin(provider) {
    return this.afAuth.auth.signInWithRedirect(provider).then(credential => {
      this.updateUserData(credential.user);
      this.loginState = true;
      console.log("loginState in Auth Service", this.user);

      this.router.navigate(['/userprofile']);

      /*if (this.redirectUrl) {
        console.log("my redirect url", this.redirectUrl);
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      }*/
      
    });
  }

  private updateUserData(user, name?) {
    // Sets user data to firestore on login. Here we will have the option to set custom data as we
    // as delay the process. User can fill out data and we store it to firebase.
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    const data: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName || name,
      photoURL:
        user.photoURL ||
        "https://firebasestorage.googleapis.com/v0/b/loveyourcamper-app.appspot.com/o/shared%2Fdummyprofile.png?alt=media&token=d7e402cf-53c4-474f-bfa3-d7f9a9e76d10",
      userBio:
        "The users profile bio would go here, of course. It could be simple as two lines.",
      updatedOn: new Date()
    };
    return userRef.set(data);
  }

  signOut() {
    this.afAuth.auth.signOut().then(() => {
      console.log("Sign Out");
      this.loginState = false;

      this.loggedIn.next(false);
      this.router.navigate(["/"]);
    });
  }

  //// Email/Password Auth ////
  emailSignUp(name: string, email: string, password: string) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(user => {
        this.updateUserData(user, name); // if using firestore
        this.router.navigate(["/userprofile"]);
      })
      .catch(error => this.handleError(error));
  }

  emailLogin(email: string, password: string) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then(user => {
        //this.updateUserData(user); // if using firestore
        this.router.navigate(["/userprofile"]);
      })
      .catch(error => this.handleError(error));
  }

  // Sends email allowing user to reset password
  resetPassword(email: string) {
    const fbAuth = firebase.auth();

    return fbAuth
      .sendPasswordResetEmail(email)
      .then(result => console.log(result))
      .catch(error => this.handleError(error));
  }

  // If error, console log and notify user
  private handleError(error: Error) {
    console.error(error);
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/core/auth.service.ts